import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';

import { CommonDataService } from '../../../services/common-data.service';
import { AuthService } from '../../../services/auth.service';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-recent-viewed-products',
  templateUrl: './recent-viewed-products.component.html',
  styleUrls: ['./recent-viewed-products.component.css']
})
export class RecentViewedProductsComponent implements OnInit {

  products = []

  constructor(private _data: CommonDataService, private authService: AuthService) { }

  ngOnInit() {
    this.getUserViewedProducts()
  }

  getUserViewedProducts() {
    let userId = sessionStorage.getItem('context')
    let modelObject1 = new FormData();
    modelObject1.append('modelName', 'Product');

    if(this.authService.isUserLoggedIn() && userId)
      modelObject1.append('context_id', userId);

  //lets get the model for this page
      this._data.getModelData(modelObject1) 
      .pipe(first())
      .subscribe(
        data => {
          console.log(data);
          this.products = data['covers']
        },
        error => {
  
        },

        () => {

        }
    );
    
  }

  getRecentProducts() {
    let modelObject1 = new FormData();
    modelObject1.append('modelName', 'Product');

  //lets get the model for this page
      this._data.getModelData(modelObject1) 
      .pipe(first())
      .subscribe(
        data => {
          console.log(data);
          this.products = data['covers']
        },
        error => {
  
        },

        () => {

        }
    );

  }

  getFeaturedProducts() {

    let modelObject1 = new FormData();
    modelObject1.append('modelName', 'Product');

    //append search query params ProductFlags-fetured set to true 
    modelObject1.append('ProductFlags-fetured', 'true');

  //lets get the model for this page
      this._data.getModelData(modelObject1) 
      .pipe(first())
      .subscribe(
        data => {
          console.log(data);
          this.products = data['covers']
        },
        error => {
  
        },

        () => {

        }
    );

  }

  getProductImageSrc(modelData){

    if( modelData['files'] && modelData['files']['uploads'] && Array.isArray(modelData['files']['uploads']) && modelData['files']['uploads'].length > 0) {
      let productImages = modelData['files']['uploads']

      for (let index = 0; index < productImages.length; index++) {
        let element = productImages[index];

        if(element['tmp_name'] && element['tmp_name'] != '') {
          let srcStrings = element['tmp_name'].split("public/");
          let src = environment.filesSrc+'/'+srcStrings[1]
          element['src'] = src
          return src
        }
        
      }

    }

      return ''
  }

}
